import Vue from 'vue'
import VueHead from 'vue-head'
Vue.use(VueHead, { complement: 'Fifty-Fifty Taxi' })